import { Component, inject, OnDestroy, Signal } from '@angular/core';
import { stages } from '../../occupation-of-lane-placement-construction-objects.routes';
import { Store } from '@ngrx/store';
import {
  OccupationOfLanePlacementConstructionObjectsForm,
  occupationsToFormValue
} from './forms/occupation-of-lane-placement-construction-objects.form';
import { ApplicationAppEntityApplicationRead, RoadOccupationAppEntityApplicationRead } from '../../../../../../openapi';
import {
  selectApplication,
  selectLoading,
  selectPending
} from '../../../../../../store/selectors/application.selectors';
import { Subscription } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import {
  updateOccupationOfLanePlacementConstructionObjects
} from '../../../../../../store/actions/application.actions';
import { StagesComponent } from '../../../../../../common/stages/stages.component';
import { SpinnerComponent } from '../../../../../../common/spinner/spinner.component';
import {
  OccupationOfLanePlacementConstructionObjectsFormComponent
} from './components/occupation-of-lane-placement-construction-objects-form/occupation-of-lane-placement-construction-objects-form.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ServiceListItem } from '../../../../../../services/service.common.model';
import { selectServiceByUrl } from '../../../../../../store/selectors/app.selectors';

@Component({
  selector: 'app-occupation-of-lane-placement-construction-objects-section',
  standalone: true,
  imports: [
    StagesComponent,
    SpinnerComponent,
    OccupationOfLanePlacementConstructionObjectsFormComponent,
    ReactiveFormsModule
  ],
  providers: [
    OccupationOfLanePlacementConstructionObjectsForm
  ],
  templateUrl: './occupation-of-lane-placement-construction-objects-section.component.html'
})
export class OccupationOfLanePlacementConstructionObjectsSectionComponent implements OnDestroy {

  public stages: string[] = stages;

  private store$: Store = inject(Store);

  private route: ActivatedRoute = inject(ActivatedRoute);

  private router: Router = inject(Router);

  public form: OccupationOfLanePlacementConstructionObjectsForm = inject(OccupationOfLanePlacementConstructionObjectsForm);

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  private fetchRoadOccupation: Subscription = toObservable(this.application).subscribe(app => {
    const occupations: Array<RoadOccupationAppEntityApplicationRead> = app?.roadOccupations || [];
    const occupation = occupationsToFormValue(occupations).at(0) || null;
    if (occupation) {
      this.form.patchFormValues(occupation);
    }
  });

  public serviceType: Signal<ServiceListItem | null> = this.store$.selectSignal(selectServiceByUrl(this.route?.parent?.snapshot?.data['contentUrl']));

  public onCancel(): void {
    this.router.navigate(['../dane-wniosku'], { relativeTo: this.route });
  }

  public submitAndGoNext(): void {
    if (this.form.valid) {
      this.store$.dispatch(updateOccupationOfLanePlacementConstructionObjects({
        application: this.application(),
        occupations: [this.form.values],
        successFnc: (applicationId) => {
          this.router.navigate(
            ['../oplaty'],
            {
              relativeTo: this.route
            }
          );
        },
        failureFnc: () => {
        }
      }));
    } else {
      this.form.markAllAsTouched();
    }
  }

  public ngOnDestroy(): void {
    this.fetchRoadOccupation.unsubscribe();
  }
}
